<template>
    <section id="dashboard" v-loading="loading">
        <el-container style="max-width: 600px">
            <el-input placeholder="Search text" v-model="search"></el-input>
            <el-button icon="el-icon-search" type="primary" @click="loadData"
                >Search</el-button
            >
            <el-button
                icon="el-icon-plus"
                type="primary"
                @click="handleEditUpdate"
                >Add User</el-button
            >
        </el-container>
        <el-table
            :default-sort="{ prop: 'id', order: 'descending' }"
            :data="tableData"
            stripe
            @sort-change="handleSortChange"
            style="width: 100%"
        >
            <el-table-column prop="id" label="ID" width="70" sortable>
            </el-table-column>
            <el-table-column
                prop="name"
                label="Name"
                sortable
            ></el-table-column>
            <el-table-column
                prop="email"
                label="E-mail"
                sortable
            ></el-table-column>
            <el-table-column fixed="right" label="" width="180">
                <template slot-scope="{ row, column, $index }">
                    <el-button
                        icon="el-icon-edit"
                        @click="handleEditUpdate(row)"
                        size="small"
                        >Edit</el-button
                    >
                    <el-popconfirm
                        title="Are you sure?"
                        @confirm="handleDelete(row)"
                    >
                        <el-button
                            slot="reference"
                            icon="el-icon-delete"
                            size="small"
                            >Delete</el-button
                        >
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40]"
            layout="sizes, prev, pager, next, total"
            :total="total"
        >
        </el-pagination>
        <el-dialog
            :title="modalTitle"
            :visible.sync="dialogVisible"
            width="1000px"
        >
            <template v-if="rowToShow">
                <el-form
                    :model="rowToShow"
                    :rules="rules"
                    ref="userForm"
                    label-width="170px"
                >
                    <el-form-item label="First Name" prop="first_name">
                        <el-input v-model="rowToShow.first_name"></el-input>
                    </el-form-item>
                    <el-form-item label="Last Name" prop="last_name">
                        <el-input v-model="rowToShow.last_name"></el-input>
                    </el-form-item>
                    <el-form-item label="E-mail" prop="email">
                        <el-input v-model="rowToShow.email"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Password"
                        prop="password"
                        :rules="[
                            {
                                required: rowToShow.id ? false : true,
                                message: 'Password is required',
                                trigger: 'blur',
                            },
                            {
                                min: 8,
                                message:
                                    'Password should be at least 8 characters',
                                trigger: 'blur',
                            },
                        ]"
                    >
                        <el-input
                            type="password"
                            v-model="rowToShow.password"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Confirm Password"
                        prop="password_confirmation"
                        :rules="[
                            {
                                required:
                                    rowToShow.id && !rowToShow.password
                                        ? false
                                        : true,
                                message: 'Password Confirmation is required',
                                trigger: 'blur',
                            },
                            {
                                validator: validatePassConfirmation,
                                trigger: 'blur',
                            },
                        ]"
                    >
                        <el-input
                            type="password"
                            v-model="rowToShow.password_confirmation"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button
                    type="primary"
                    @click="saveUser"
                    v-loading.fullscreen.lock="fullScreenLoading"
                    >Save</el-button
                >
            </span>
        </el-dialog>
    </section>
</template>

<script>
import adminApi from "../api";

export default {
    name: "Dashboard",
    data() {
        return {
            loading: false,
            search: null,
            formType: null,
            currentPage: 1,
            pageSize: 10,
            descriptionColumns: 2,
            sort: { prop: "id", order: "descending" },
            total: 0,
            tableData: [],
            dialogVisible: false,
            rules: {
                first_name: [
                    {
                        required: true,
                        message: "Please input name",
                        trigger: "blur",
                    },
                    {
                        min: 3,
                        max: 255,
                        message: "Length should be 3 to 255",
                        trigger: "blur",
                    },
                ],
                last_name: [
                    {
                        required: true,
                        message: "Please input name",
                        trigger: "blur",
                    },
                    {
                        min: 3,
                        max: 255,
                        message: "Length should be 3 to 255",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: "Please input email",
                        trigger: "blur",
                    },
                    {
                        min: 3,
                        max: 255,
                        message: "Length should be 3 to 255",
                        trigger: "blur",
                    },
                    {
                        type: "email",
                        message: "Please input correct email address",
                        trigger: "blur",
                    },
                ],
            },
            rowSample: {
                id: null,
                first_name: null,
                last_name: null,
                password: null,
                password_confirmation: null,
                email: null,
            },
            rowToShow: null,
            fullScreenLoading: false,
        };
    },
    created() {
        this.loadData();
    },
    computed: {
        modalTitle() {
            if (this.rowToShow && this.rowToShow.id) {
                return "Edit User";
            }
            return "Create User";
        },
    },
    methods: {
        validatePassConfirmation(rule, value, callback) {
            if (value && value !== this.rowToShow.password) {
                callback(
                    new Error("Password and password confirmation must match")
                );
            } else {
                callback();
            }
        },
        saveUser() {
            this.$refs["userForm"].validate((valid) => {
                if (valid) {
                    this.fullScreenLoading = true;
                    adminApi
                        .saveUser(this.rowToShow)
                        .then((r) => {
                            if (r && r.data && r.data.success) {
                                this.$notify({
                                    title: "Success",
                                    message: "The user was saved successfully!",
                                    type: "success",
                                    duration: 10000,
                                });
                                this.dialogVisible = false;
                                this.loadData();
                            } else {
                                this.$notify({
                                    title: "Error",
                                    message:
                                        "Please make sure you filed the form correctly, check if the e-mail is already used and try again.",
                                    type: "error",
                                    duration: 10000,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$notify({
                                title: "Error",
                                message:
                                    "Something went wrong! Please contact the webmaster mentioning the action you were trying to perform.",
                                type: "error",
                                duration: 10000,
                            });
                        })
                        .finally(() => {
                            this.fullScreenLoading = false;
                        });
                } else {
                    this.$notify({
                        title: "Error",
                        message:
                            "Please make sure you filled in the form correctly.",
                        type: "error",
                        duration: 10000,
                    });
                    return false;
                }
            });
        },
        getFile(fileName) {
            window
                .open("/api/v1/admin/file?filename=" + fileName, "_blank")
                .focus();
        },
        handleEditUpdate(row) {
            if (row) {
                this.rowToShow = JSON.parse(JSON.stringify(row));
            } else {
                this.rowToShow = JSON.parse(JSON.stringify(this.rowSample));
            }
            this.dialogVisible = true;
        },
        handleDelete(row) {
            this.loading = true;
            adminApi
                .deleteUser(row.id)
                .then((r) => {
                    if (r && r.data && r.data.success) {
                        this.$notify({
                            title: "Success",
                            message: "The user was deleted successfully!",
                            type: "success",
                            duration: 10000,
                        });
                        this.dialogVisible = false;
                        this.loadData();
                    } else {
                        let errorMessage =
                            "Oops, we could not delete the user. Please try again!";
                        if (r && r.data && r.data.message) {
                            errorMessage = r.data.message;
                        }
                        this.$notify({
                            title: "Error",
                            message: errorMessage,
                            type: "error",
                            duration: 10000,
                        });
                    }
                })
                .catch((err) => {
                    this.$notify({
                        title: "Error",
                        message:
                            "Something went wrong! Please contact the webmaster mentioning the user id.",
                        type: "error",
                        duration: 10000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSortChange({ column, prop, order }) {
            if (!order) {
                this.sort = { prop: "id", order: "desc" };
            } else {
                this.sort = { prop: prop, order: order };
            }
            this.loadData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            adminApi
                .getAdminUserList({
                    search: this.search,
                    formType: this.formType,
                    page: this.currentPage,
                    perPage: this.pageSize,
                    orderBy: this.sort.prop,
                    orderWay: this.sort.order == "ascending" ? "asc" : "desc",
                })
                .then((r) => {
                    this.tableData = r.data.data;
                    this.total = r.data.total;
                })
                .catch((err) => {})
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-select--mini .el-input__inner {
    padding-right: 0 !important;
}
</style>
